import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import AccountUsers from './component';

const selector = createSelector([], () => ({}));

export default connect(
  selector,
)(AccountUsers);
